<template>
    <div class="row mt-3 servicios-adicionales">
        <div class="col">
            <table class="table table-bordered">
                <thead>
                    <tr>
                        <th>{{ $t("tramiteEnergia.servicios.label") }}</th>
                        <th>{{ $t("tramiteEnergia.servicios.costeConDescuentos") }}</th>
                        <th>{{ $t("shared.ui.literals.status") }}</th>
                        <th v-if="puedeVerCoste">{{ $t("tramiteEnergia.servicios.comision") }}</th>
                        <th v-if="puedeVerCoste">{{ $t("tramiteEnergia.servicios.retrocomision") }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="servicio in servicios" :key="servicio.Nombre">
                        <td>{{ servicio.Nombre }}</td>
                        <td class="text-end">{{ aplicarImpuestos(servicio.CosteConDescuentos) }} €/mes</td>
                        <td>
                            <span v-if="!fechaActivacionTramite" class="servicio-pdt-activacion d-inline-block px-2 py-1 rounded">{{$t("tramiteEnergia.servicios.estados.pdtActivacion")}}</span>
                            <span v-else-if="servicio.FechaBaja" class="servicio-baja d-inline-block px-2 py-1 rounded">{{$t("tramiteEnergia.servicios.estados.baja")}}</span>
                            <span v-else class="servicio-activo d-inline-block px-2 py-1 rounded">{{$t("tramiteEnergia.servicios.estados.activo")}}</span>
                        </td>
                        <td v-if="puedeVerCoste" class="text-end">
                            <DesgloseRetribucionEconomica
                                :importe-total="servicio.ComisionEfectiva"
                                :importe-calculado="servicio.Comision"
                                :importe-reajuste="servicio.ReajusteComision"
                                :motivo-reajuste="servicio.MotivoReajusteComision"
                            />
                        </td>
                        <td v-if="puedeVerCoste" class="text-end">
                            <DesgloseRetribucionEconomica
                                :importe-total="servicio.RetrocomisionEfectiva"
                                :importe-calculado="servicio.Retrocomision"
                                :importe-reajuste="servicio.ReajusteRetrocomision"
                                :motivo-reajuste="servicio.MotivoReajusteRetrocomision"
                                es-retrocomision
                            />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script lang="ts" setup>
import type { DetailServicioTramiteOperacionEnergiaModel } from "@api/api";
import type { Impuesto } from "@helpers/impuestos-helper";
import DesgloseRetribucionEconomica from "@/.shared/components/operacion/DesgloseRetribucionEconomica.vue";

const props = defineProps<{
  servicios: DetailServicioTramiteOperacionEnergiaModel[];
  impuestosActivo: boolean;
  impuesto: Impuesto;
  fechaActivacionTramite: Date | null;
  puedeVerCoste: boolean;
}>();

const aplicarImpuestos = (precio: number) => {
  if (props.impuesto)
    return props.impuestosActivo
      ? parseFloat((precio * props.impuesto.Valor).toFixed(2))
      : precio;

  return precio;
};
</script>

<style lang="scss" scoped>


.servicios-adicionales {
  font-size: .825rem;

  table thead th {
    background: var(--grid-header-background);
    color: var(--text-default-inverse);

    &:nth-child(1) {
      min-width: 300px;
    }

    &:last-child {
      width: 135px;
    }
  }

  table tbody td {
    vertical-align: middle;
  }

  .servicio-activo {
    background-color: var(--background-secondary-default);
    color: var(--text-default-inverse);
  }

  .servicio-baja {
    background-color: var(--background-error-default);
    color: var(--text-default-inverse);
  }

  .servicio-pdt-activacion {
    background-color: var(--background-warning-default);
    color: black;
  }
}

:deep(.servicios-adicionales span.dx-button-text) {
  font-size: .75rem !important;
}
</style>
